<template>
    <ui-modal :title="title" :close="() => { close(); afterClose?afterClose():null; }">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <span class="text-blue-400 items-center justify-center fas fa-passport">
                </span>
            </div>
        </template>
        <div>
            <ui-input label="Current password" v-model="currentPassword"
                      name="current-password"
                      placeholder="Enter your current password..."
                      class="xl:col-span-12 mt-1"
                      type="password"
                      @input="error = false"
                      @focus=""
                      :disabled="busy"
                      :read-only="busy"
            ></ui-input>
            <div class="text-red-600 text-sm pt-1 pb-1 ml-3" v-if="error" v-text="error"></div>
            <hr class="mb-2 mt-4"/>
            <div class="text-gray-500 text-sm pt-0 pb-1">Passwords must be at least 8 letters long and contain a letter,
                a number and one non alpha-numeric character.
            </div>
            <ui-input label="New password" v-model="newPassword"
                      placeholder="Enter a new password..."
                      name="password"
                      class="xl:col-span-12 mt-1"
                      type="password"
                      @input="passwordError = false"
                      @focus=""
                      :disabled="busy"
                      :read-only="busy"
            ></ui-input>
            <ui-input label="Re-enter new password" v-model="confirmPassword"
                      placeholder="Re-enter the new password..."
                      class="xl:col-span-12 mt-1"
                      type="password"
                      @input="passwordError = false"
                      @focus=""
                      :disabled="busy"
                      :read-only="busy"
            ></ui-input>
            <div class="text-red-600 text-sm pt-1 pb-1 ml-3" v-if="passwordError" v-text="passwordError"></div>

        </div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new primary class="w-full whitespace-nowrap" :loading="busy" @click="update"
                               v-text="'Update Password'"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>
import UiInput from "../ui/UiInput.vue";
import PackageContactSearch from "../contacts/PackageContactSearch.vue";
import UiButtonNew from "../ui/UiButtonNew.vue";
import UiTextarea from "../ui/UiTextarea.vue";

export default {
    components: {UiTextarea, UiButtonNew, PackageContactSearch, UiInput},
    props: {
        handle: Function,
        close: Function,
        afterClose: Function,
        title: {
            type: String,
            default: ''
        },
        button: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
            error: false,
            passwordError: false,
            busy: false,
        }
    },
    methods: {
        async update() {
            this.busy = true;
            this.error = false;
            this.passwordError = false;
            if (this.newPassword !== this.confirmPassword) {
                this.passwordError = 'New password and Re-enter of new password must match!'
                this.busy = false;
            } else {
                try {
                    let data = {
                        currentPassword: this.currentPassword,
                        newPassword: this.newPassword
                    };
                    await Http.post(route('api.v2.organization.user.profile.password'), data)
                    this.handle(data, this)
                } catch (error) {
                    let body = JSON.parse(error.request.response);
                    if (body.message.includes("Current Password is incorrect")) {
                        this.error = body.message
                    } else {
                        this.passwordError = body.message
                    }
                }
                this.busy = false;
            }
        },
    },
    mounted() {
    }
}
</script>
